import { TRACKING_STATUS } from '@constant/steps';
import { useCurrentStep } from '@context/MainContext';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TransferTrackingDetailsCont from './TransferTrackingCont';

const TransferTrackingStatus = () => {
	const theme = useTheme();
	const { t } = useTranslation();
	const currentStep = useCurrentStep();
	const { title, subtitle, icon } = TRACKING_STATUS[currentStep];

	return (
		<>
			<TransferTrackingDetailsCont>
				<Grid container direction="column" alignItems="center">
					<Grid item sx={{ padding: '24px' }}>
						<Box component="img" src={icon} />
					</Grid>
					<Grid item>
						<Typography variant="h4" color={theme.text.primary}>
							{t(title)}
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="h6" color={theme.text.secondary} sx={{ fontWeight: '600' }}>
							{t(subtitle)}
						</Typography>
					</Grid>
				</Grid>
			</TransferTrackingDetailsCont>
		</>
	);
};

export default TransferTrackingStatus;
